import { Link } from "react-router-dom";
import { useSite } from "../context/SiteContext";
import { Reveal } from "./Reveal";
import { IconGlobe, IconPin } from "./Icons";

export const CTABand = () => {
  const { settings } = useSite();
  const c = settings?.contact || {};
  return (
    <section className="cta section" data-testid="cta-band">
      <div className="wrap cta-in">
        <Reveal>
          <span className="eyebrow light">Ensuring quality, enabling trade</span>
          <h2 style={{ marginTop: 16 }}>
            Ready to strengthen your <span className="g">compliance &amp; quality?</span>
          </h2>
          <p>
            Let's build a plan that protects public health, reduces risk, and opens doors to global
            markets. {c.location}.
          </p>
        </Reveal>
        <Reveal className="cta-actions" delay={80}>
          <Link to="/contact" className="btn btn-light" data-testid="cta-consultation">
            Request a consultation
          </Link>
          <a href={`mailto:${c.email}`} className="btn btn-outline-light" data-testid="cta-email">
            {c.email}
          </a>
          <div className="contact-line"><IconGlobe /> {c.website}</div>
          <div className="contact-line"><IconPin /> {c.location}</div>
        </Reveal>
      </div>
    </section>
  );
};
